module.exports = __webpack_public_path__ + "static/media/savio7.33bdc0c8.jpg";